import { FONT_WEIGHT } from '../../foundations/typography';
import { AccordionVariantType, SelectorRowVariants, TextVariantType, ToggleVariantType, } from '../variants';
export const commonStyles = (FOUNDATIONS, FONT) => ({
    accordionVariant: AccordionVariantType.ACCORDION_WITH_TOGGLE,
    selectorRowVariant: SelectorRowVariants.WITH_TOGGLE,
    toggleVariant: ToggleVariantType.REGULAR,
    description: {
        font_variant: TextVariantType.FONT_PARAGRAPH_350,
        font_weight: FONT_WEIGHT.font_regular,
        color: FOUNDATIONS.color_neutral_bg_onsurface_50,
    },
    accordionContainerOpened: {
        background_color: FOUNDATIONS.color_comp_containers_bg,
        border_radius: FOUNDATIONS.radius_250,
    },
    contentContainer: {
        padding: `${FOUNDATIONS.spacing_200} ${FOUNDATIONS.spacing_250} ${FOUNDATIONS.spacing_250} ${FOUNDATIONS.spacing_250}`,
    },
    footerSelectorRowContainer: {
        margin_top: FOUNDATIONS.spacing_50,
        padding: `${FOUNDATIONS.spacing_100} ${FOUNDATIONS.spacing_150} ${FOUNDATIONS.spacing_100} ${FOUNDATIONS.spacing_350}`,
        background_color: FOUNDATIONS.color_comp_containers_bg,
        border_radius: `0 0 ${FOUNDATIONS.radius_250} ${FOUNDATIONS.radius_250}`,
    },
    footerContentContainer: {
        margin_top: FOUNDATIONS.spacing_50,
        padding: `${FOUNDATIONS.spacing_100} ${FOUNDATIONS.spacing_150} ${FOUNDATIONS.spacing_100} ${FOUNDATIONS.spacing_450}`,
        background_color: FOUNDATIONS.color_comp_containers_bg,
        border_radius: `0 0 ${FOUNDATIONS.radius_250} ${FOUNDATIONS.radius_250}`,
    },
    footerDisabled: {
        background_color: FOUNDATIONS.color_accent_disabled_bg_100,
    },
});
//# sourceMappingURL=commonStyles.js.map